import axios from "axios";
// import ElNotification from "element-plus/lib/el-notification/index";
import { ElNotification } from "element-plus";
import { showLoading, hideLoading } from "./loading";
import router from "./../router";
import Cookies from "js-cookie";
import store from "./../store";
let ip;

const envBase = process.env.VUE_APP_BASE_API;
let zhenshi = "http://xqy.xiquepark.net:8080";
if (envBase) {
  // 显式注入的环境（gray 等）优先，避免 NODE_ENV=development 时走下面的写死分支
  ip = envBase;
} else if (process.env.NODE_ENV === "development") {
  // ip = "http://gateway.parkyes.com"; // 正式
  ip = "http://gateway.szhntc.cn"; // 红牛停车 //
  // ip = "http://gatewaycloud.szhntc.cn"; // 红牛停车测试
  // ip = "http://192.168.1.110:8080"; // 红牛停车测试 吴
  // ip = "http://192.168.1.122:8080"; // 红牛停车测试 徐 http://192.168.1.123:8080
  // ip = "https://apicloud.szhntc.cn"
} else if (process.env.NODE_ENV === "test") {
  // ip = "http://gateway.szhntc.cn";
  ip = "http://gatewaycloud.szhntc.cn"; // 红牛停车测试
} else {
  // ip = "http://gateway.parkyes.com";
  // ip="http://gateway.parkyes.com"//机智云正式
  // ip = "http://gatewaycloud.szhntc.cn"; // 红牛停车测试
  ip = "http://gateway.szhntc.cn"; // 红牛停车
}
const token = Cookies.get("token_type") + ' ' + Cookies.get("token");
const instance = axios.create({
  baseURL: ip,
  timeout: 20000,
  headers: {
    "X-Custom-Header": "foobar",
    // Authorization: token,
    // Platform: Cookies.get("platform"),
    // projectid: Cookies.get("parkId") || '',
  },
  validateStatus: function (status) {
    return status < 500; // 状态码在大于或等于500时才会 reject
  },
});

instance.interceptors.request.use(
  function (config) {
    let platform = Cookies.get("platform")
    let parkId = store.getters.currentParkId
    /* if(!Cookies.get("token")){
      router.replace("/about");
      return;
    } */
    let token = Cookies.get("token_type") + ' ' + Cookies.get("token")
    config.headers.Authorization = token
    // 显示loading
    if (platform) {
      if (platform === 'admin_service' || platform === 'admin') {
        config.headers.Platform = config.headers.isService ? platform : parkId ? 'admin_project' : platform;
      } else {
        config.headers.Platform = platform;
      }
    }
    if (parkId) {
      config.headers.projectid = parkId;
    }
    if (!config.headers.noLoading) {
      showLoading();
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    hideLoading();

    if (response.data.code === 401) {
      ElNotification.warning({ message: response.data.msg });

      router.replace("/about");
      return new Promise(function () { });
    }
    // 业务失败不抛异常：避免页面未捕获的 Promise rejection 触发红色遮罩层
    if (response.data && response.data.code !== 200) {
      ElNotification.warning({ message: response.data.msg });
    }
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    hideLoading();
    // 网络错误/超时等：不抛异常，返回统一结构给调用方处理
    const msg =
      (error && error.message) ||
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.msg) ||
      "请求失败!";
    ElNotification.warning({ message: msg });
    return Promise.resolve({
      code: -1,
      msg,
      data: null,
      _networkError: true,
    });
  },
);
export default instance;
